import graphql__b87794e51ab77890665e from "./__generated__/MapFilterList_filterList.graphql.js";import { createFragmentContainer } from "react-relay";
import { graphql } from "react-relay";

import MapFilter from "./MapFilter";

const MapFilterList = props => {
  const { filters } = props.filterList;

  return (
    <>
      {filters.map(filter => (
        <MapFilter key={filter.id} filter={filter} />
      ))}
    </>
  );
};

export default createFragmentContainer(MapFilterList, {
  filterList: graphql__b87794e51ab77890665e
});
